// Proxy hook: returns the real Auth0 hook in prod, a no-op shim in dev mode.
// When REACT_APP_DEV_NO_AUTH=true, the app behaves as if a fixed dev user is logged in.

import { useAuth0 as useAuth0Real } from '@auth0/auth0-react';

const DEV = process.env.REACT_APP_DEV_NO_AUTH === 'true';

// Stable references outside the hook so useMemo/useCallback deps don't re-fire on every render.
const DEV_USER = { name: 'Dev User', email: 'dev@theaviary.local', picture: 'https://api.dicebear.com/7.x/initials/svg?seed=Dev' };
const DEV_LOGIN = async () => {};
const DEV_LOGOUT = () => { /* eslint-disable-next-line no-alert */ alert('Logout disabled in DEV mode.'); };
const DEV_GET_TOKEN = async () => 'dev-token';

function useAuth0Dev() {
  return {
    isLoading: false,
    isAuthenticated: true,
    user: DEV_USER,
    loginWithRedirect: DEV_LOGIN,
    logout: DEV_LOGOUT,
    getAccessTokenSilently: DEV_GET_TOKEN,
  };
}

export const useAuth0 = DEV ? useAuth0Dev : useAuth0Real;
export const IS_DEV_AUTH = DEV;
